import React, { Component } from "react";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables-bitozen";
import LoadingBar from "react-top-loading-bar";
import PopUp from "../../../pages/PopUpAlert";
import API from "../../../../Services/Api";
import { checkResponseError } from "../../../../Services/Utils";
import { connect } from "react-redux";
import * as R from "ramda";
import { Redirect } from "react-router-dom";
import AuthAction from "../../../../Redux/AuthRedux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";

import FormPDI from "../../delivery/delivery/formPDIFinal";
import FormVarian from "./formInventory";

import Button from "../../../../modules/commons/Button";
import DDLSeries from "../../../../modules/commons/DDLSeries";
import SimpleInputRow from "../../../../modules/SimpleInputRow";
import DDLCompany from "../../../../modules/commons/DDLCompany";
import SimpleInput from "../../../../modules/SimpleInput";
import FormKSU from "./formKSU";
import FormBattery from "./formBattery";
import { max } from "date-fns";

const UtilsButtonLogin = require("../../../../Services/UtilsButtonLogin");

const ct = require("../../../../modules/custom/customTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions6();

class prospek extends Component {
  constructor() {
    super();
    this.state = {
      rawData: [],
      dataTable: [
        ["1", "Vario", "91698G67", "New", "Motor", "Jakarta", "6", "8", "10"],
        ["2", "NMax", "23456H78", "Used", "Motor", "Bandung", "7", "9", "12"],
        ["3", "PCX", "78901I89", "New", "Motor", "Surabaya", "8", "10", "14"],
        ["4", "Beat", "34567J90", "Used", "Motor", "Yogyakarta", "6", "8", "10"],
        ["5", "Scoopy", "12345K12", "New", "Motor", "Semarang", "7", "9", "12"],
        ["6", "Mio", "67890L34", "Used", "Motor", "Medan", "6", "8", "10"],
        ["7", "Vespa", "90123M56", "New", "Motor", "Denpasar", "8", "10", "14"],
        ["8", "Satria", "45678N90", "Used", "Motor", "Makassar", "7", "9", "12"]
      ],
      dataTable2: [
        ["1", "Leon", "Cabang", "New", "2", "LMS", "Solo", "A", "XL", "19"],
        ["2", "Eva", "Pusat", "Used", "3", "VTR", "Jakarta", "B", "L", "21"],
        ["3", "Riko", "Pusat", "New", "1", "NML", "Bandung", "C", "M", "18"],
        ["4", "Maya", "Cabang", "Used", "4", "PQR", "Surabaya", "D", "S", "20"],
        ["5", "Ryan", "Pusat", "New", "2", "WXY", "Yogyakarta", "E", "XXL", "22"],
        ["6", "Sari", "Cabang", "Used", "3", "JKL", "Semarang", "F", "S", "20"],
      ],
      dataTable3: [
        ["1", "Legal", "91698G67", "100", "Robotic", "Jakarta", "6", "8", "10"],
        ["2", "Financial", "23456H78", "200", "AI", "Bandung", "7", "9", "12"],
        ["3", "Medical", "78901I89", "150", "Nanotech", "Surabaya", "8", "10", "14"],
        ["4", "Educational", "34567J90", "180", "Automation", "Yogyakarta", "6", "8", "10"],
        ["5", "Agricultural", "12345K12", "120", "Machine Learning", "Semarang", "7", "9", "12"],
        ["6", "Industrial", "67890L34", "220", "Data Analysis", "Medan", "6", "8", "10"],
        ["7", "Transportation", "90123M56", "170", "Augmented Reality", "Denpasar", "8", "10", "14"],
      ],
      selectedIndex: [],
      createVisible: false,
      createVisible2: false,
      createVisible3: false,
      updateVisible: false,
      deletePopUpVisible: false,
      savePopUpVisible: false,
      failedPopUpVisible: false,
      loadSave: false,
      allowResize: false,
      defaultSize: 0,
      minSize: 0,
      maxSize: 0,
      timeout: 1000 * 100 * 9,
      isTimedOut: false,
      toCount: 0,
      table_limit: 10,
      table_page: 0,
      table_query: "",
      createVisible2: false,
      tabIndex: 0,
      checkTab: false,
      data: {},
      dataDto: {},
      segmenType: [
        { label: "Matic", value: "Matic" },
        { label: "CUB", value: "CUB" },
        { label: "Sporty", value: "Sporty" },
      ],
      selectedSegmenData: {},
      selectedSubSegmenData: {},
      seriesInput: {},

      subSegmenType: [
        { label: "Low", value: "Low" },
        { label: "Mid", value: "Mid" },
        { label: "High", value: "High" },
      ],
      buttonAccess: {},
    };
    this.idleTimer = null;
  }

  logout() {
    this.props.authLogout();
    return <Redirect to={{ pathname: "/" }} />;
  }

  onAction() {
    this.setState({ isTimedOut: false });
  }

  onActive() {
    this.setState({ isTimedOut: false });
  }

  onIdle() {
    const isTimedOut = this.state.isTimedOut;
    if (isTimedOut) {
      alert("Your session has timed out. Please log in again");
      this.logout();
    } else {
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  }

  componentDidMount() {
    UtilsButtonLogin.buttonAccess("MASTER-022", (response) => {
      // console.log("ORI ", response);
      this.setState(
        {
          buttonAccess: response,
        },
        () => {
          this.getCountPage(this.state.table_page, this.state.table_limit);
        }
      );
    });
  }

  getCountPage = async (page, limit) => {
    let payload = {
      limit: limit,
      offset: page,
      // filter: this.state.table_query,
      // companyId: this.state.dataDto.companyId,
      // companyGroupId: null,
      // category: null,
      // isActive: null,
      // sortBy: this.state.dataDto.sortBy ?? "",
      // orderBy: this.state.dataDto.orderBy ?? "",
    };

    let res = await API.create("LOCAL_SERIES").getSeries(payload);
    if (res.ok) {
      if (res.data.data === null) {
        this.setState({ dataTable: [] });
      } else {
        // console.log(JSON.stringify(res.data.data, null, 2));
        let dataTable =
          res.data.data &&
          res.data.data.map((value) => {
            const { id, segmen, subsegmen, series } = value;
            return [id, segmen, subsegmen, series];
          });
        this.setState({
          rawData: res.data.data && res.data.data.listUser,
          dataTable,
          toCount: res.data.data && res.data.data.dataOfRecord,
        });
        this.onFinishFetch();
      }
    }
  };

  handleClearUser = (e) => {
    this.setState(
      {
        table_page: 0,
        toCount: 0,
        data: {},
        dataDto: {},
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  handleSearch = (eventSearch) => {
    this.setState(
      {
        table_page: 0,
        dataDto: eventSearch ? this.state.data : this.state.dataDto,
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  isLoad(visible) {
    this.setState({ loadSave: visible });
  }

  checkResponse(res, type) {
    if (res.ok && res.data.status === "S") {
      type === "delete" && this.setState({ deletePopUpVisible: false });
      setTimeout(() => {
        this.openSavePopUp();
      }, 500);
    } else {
      this.isLoad(false);
      checkResponseError(res);
    }
  }

  handleSubmit = async (response) => {
    this.checkResponse(response);
  };

  handleDelete = async () => {
    this.isLoad(true);
    let payload = { ...this.state.rawData[this.state.selectedIndex] };
    payload.action = "DELETE";

    let response = await API.create("MASTERDATA_EKSAD").postSaveUser(payload);
    this.checkResponse(response, "delete");
    this.isLoad(false);
  };

  handlePopUp = () => {
    this.handleSearch();
    this.setState({
      savePopUpVisible: false,
      createVisible: false,
      createVisible2: false,
      createVisible3: false,
    });
  };

  handlePopUp2 = () => {
    this.handleSearch();
    this.setState({
      failedPopUpVisible: false,
      createVisible: false,
      createVisible2: false,
      createVisible3: false,
    });
  };

  startFetch = () => {
    this.LoadingBar.continousStart();
  };

  onFinishFetch = () => {
    if (typeof this.LoadingBar === "object") this.LoadingBar.complete();
  };

  openCreateForm = () => {
    this.setState({ createVisible: !this.state.createVisible });
  };

  openCreateForm2 = () => {
    this.setState({ createVisible2: !this.state.createVisible2 });
  };

  openCreateForm3 = () => {
    this.setState({ createVisible3: !this.state.createVisible3 });
  };

  openUpdateForm = () => {
    this.setState({ updateVisible: !this.state.updateVisible });
  };

  openSavePopUp = () => {
    this.setState({
      savePopUpVisible: !this.state.savePopUpVisible,
      loadSave: false,
    });
  };

  openFailedPopUp = () => {
    this.setState({
      failedPopUpVisible: !this.state.failedPopUpVisible,
      loadSave: false,
    });
  };

  openDeletePopup = (index) => {
    this.setState({
      deletePopUpVisible: !this.state.deletePopUpVisible,
      selectedIndex: index,
    });
  };
  columnsBattery = [
    { name: "No" },
    { name: "Tipe Series" },
    { name: "SKU Code" },
    { name: "Capacity" },
    { name: "Model" },
    { name: "Locator" },
    { name: "QTY RFS" },
    { name: "QTY NRFS" },
    { name: "QTY Alloc" },
    {
      name: "Action",
      options: {
        customBodyRender: (val, tableMeta) => {
          return (
            <div style={{ width: "115px" }}>
              <Button
                className="btnAct"
                style={{ marginRight: 15, backgroundColor: "transparent" }}
                onClick={this.openCreateForm3.bind(this)}
                permission=""
              >
                <i
                  className="fa fa-lw fa-pencil-alt"
                  style={{
                    backgroundColor: "transparent",
                    color: "red",
                    fontSize: 20,
                  }}
                />
              </Button>
              {/* <Button
                                className="btnAct"
                                style={{ marginRight: 15, backgroundColor: 'transparent' }}
                                onClick={() => this.openDeletePopup(tableMeta.rowIndex)}
                                permission={this.state.buttonAccess.btnDelete}
                            >
                                <i className="fa fa-lw fa-trash-alt"
                                    style={{ backgroundColor: 'transparent', color: 'red', fontSize: 20 }} />
                            </Button> */}
            </div>
          );
        },
      },
    },
  ];

  columnsUser = [
    { name: "No" },
    { name: "Nama Prospek" },
    { name: "Leads ID" },
    { name: "Tgl Leads" },
    { name: "Last FU" },
    { name: "Chanel" },
    { name: "No Hp" },
    { name: "Email" },
    { name: "Sales" },
    { name: "Event" },
    {
      name: "Action",
      options: {
        customBodyRender: (val, tableMeta) => {
          return (
            <div style={{ width: "115px" }}>
              <Button
                className="btnAct"
                style={{ marginRight: 15, backgroundColor: "transparent" }}
                onClick={this.opSidePage(
                  "slide-menu-1",
                  tableMeta.rowIndex,
                  "companyGroup"
                )}
                permission=""
              >
                <i
                  className="fa fa-lw fa-pencil-alt"
                  style={{
                    backgroundColor: "transparent",
                    color: "red",
                    fontSize: 20,
                  }}
                />
              </Button>
            </div>
          );
        },
      },
    },
  ];

  columnsKSU = [
    { name: "No" },
    { name: "Nama KSU" },
    { name: "Category" },
    { name: "SKU" },
    { name: "Unit" },
    { name: "UTP" },
    { name: "Locator" },
    { name: "NRFS" },
    { name: "RFS" },
    { name: "QTY Alloc" },
    {
      name: "Action",
      options: {
        customBodyRender: (val, tableMeta) => {
          return (
            <div style={{ width: "115px" }}>
              <Button
                className="btnAct"
                style={{ marginRight: 15, backgroundColor: "transparent" }}
                onClick={this.openCreateForm2.bind(this)}
                permission=""
              >
                <i
                  className="fa fa-lw fa-pencil-alt"
                  style={{
                    backgroundColor: "transparent",
                    color: "red",
                    fontSize: 20,
                  }}
                />
              </Button>
              {/* <Button
                                className="btnAct"
                                style={{ marginRight: 15, backgroundColor: 'transparent' }}
                                onClick={() => this.openDeletePopup(tableMeta.rowIndex)}
                                permission={this.state.buttonAccess.btnDelete}
                            >
                                <i className="fa fa-lw fa-trash-alt"
                                    style={{ backgroundColor: 'transparent', color: 'red', fontSize: 20 }} />
                            </Button> */}
            </div>
          );
        },
      },
    },
  ];

  opSidePage = (menu, data) => (e) => {
    e.preventDefault();
    let selectedIndex = data;
    this.setState({
      updateVisible: false,
    });

    switch (menu) {
      case "slide-menu-1":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "update",
        });
        break;
      case "slide-menu-view":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "view",
        });
        break;
      default:
        break;
    }
  };
  resetTab = (tabIndex) => {
    this.setState({ tabIndex });
    if (tabIndex === 0) {
      this.getCountPage(this.state.table_page, this.state.table_limit);
    }
  };

  onchangeInput = (event) => {
    let nama = event.target.name;
    let value = event.target.value;
    this.setState({
      seriesInput: {
        ...this.state.seriesInput,
        [nama]: value,
      },
    });
  };

  onPostCreate = async () => {
    console.log("masuk function onPostCreate");
    if (
      R.isEmpty(this.state.seriesInput) ||
      R.isEmpty(this.state.selectedSegmenData) ||
      R.isEmpty(this.state.selectedSubSegmenData)
    ) {
      console.log("payload error");
      this.openFailedPopUp();
    } else {
      console.log("payloadCreated");
      let payloadCreate = {
        segmen: this.state.selectedSegmenData.SegmenSelect.value,
        subSegmen: this.state.selectedSubSegmenData.SubSegmenSelect.value,
        series: this.state.seriesInput.kodeId,
      };
      console.log("payloadCreate", typeof payloadCreate.series);

      let response = await API.create("LOCAL_SERIES").postCreateSeries(
        payloadCreate
      );
      if (response.data.code === 201) {
        console.log("postCreateSeriesSuccess", response);
        this.openSavePopUp();
      } else {
        // pop up gagal
        console.log("postCreateSeriesFailed", response);
        this.openFailedPopUp();
      }
    }
  };

  onClearFieldButton = () => {
    this.setState({
      selectedSegmenData: {},
      selectedSubSegmenData: {},
      seriesInput: {},
    });
  };

  render() {
    if (R.isNil(this.props.auth.user))
      return <Redirect to={{ pathname: "/" }} />;
    let { toCount, table_query } = this.state;
    let tableOptions = {
      ...options,
      filter: false,

      count: toCount,
      searchText: table_query,
      search: false,
      viewColumns: false,
      rowsPerPage: this.state.table_limit,
      page: this.state.table_page,
      onColumnSortChange: (changedColumn, direction) => {
        let order = "desc";
        if (direction === "ascending") {
          order = "asc";
        }

        let columnOrder = "";

        if (changedColumn === "Company") {
          columnOrder = "companyCode";
        }

        if (changedColumn === "Username") {
          columnOrder = "username";
        }

        if (changedColumn === "Email") {
          columnOrder = "email";
        }

        if (changedColumn === "Category") {
          columnOrder = "category";
        }

        if (changedColumn === "Employee Name") {
          columnOrder = "name";
        }

        if (changedColumn === "Status") {
          columnOrder = "status";
        }

        this.columnsUser.map((value, index) => {
          if (changedColumn === value.name && value.name !== "Action") {
            value.options = { sortDirection: order };
          } else {
            value.options = { ...value.options, sortDirection: "none" };
          }
        });

        this.setState(
          {
            dataDto: {
              ...this.state.dataDto,
              sortBy: columnOrder,
              orderBy: order,
            },
          },
          () => {
            this.getCountPage(this.state.table_page, this.state.table_limit);
          }
        );
      },
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.setState({ table_page: tableState.page });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.setState({ table_limit: tableState.rowsPerPage });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "search":
            let searchText = tableState.searchText ? tableState.searchText : "";
            this.setState({ table_query: searchText }, () => {
              this.handleSearch();
            });
            break;
          default:
            break;
        }
      },
    };
    return (
<div className="main-slider">
    <div className="padding-tbl-monitoring">
      <LoadingBar onRef={(ref) => (this.LoadingBar = ref)} />
      <div style={{display:"flex", justifyContent:"space-around",alignContent:"center"}}>
        <div style={{
          backgroundColor: '#f7f7f7',
          padding: 10,
          border: '1px solid #ddd',
          borderRadius: 10,
          width: 150,
          margin: 10,
          textAlign: 'center'
        }}>
          <h1>999</h1>
          <p>New Prospek</p>
        </div>
        <div style={{
          backgroundColor: '#f7f7f7',
          padding: 10,
          border: '1px solid #ddd',
          borderRadius: 10,
          width: 150,
          margin: 10,
          textAlign: 'center'
        }}>
          <h1>999</h1>
          <p>Pending</p>
        </div>
        <div style={{
          backgroundColor: '#f7f7f7',
          padding: 10,
          border: '1px solid #ddd',
          borderRadius: 10,
          width: 150,
          margin: 10,
          textAlign: 'center'
        }}>
          <h1>999</h1>
          <p>Deal</p>
        </div>
        <div style={{
          backgroundColor: '#f7f7f7',
          padding: 10,
          border: '1px solid #ddd',
          borderRadius: 10,
          width: 150,
          margin: 10,
          textAlign: 'center'
        }}>
          <h1>9999</h1>
          <p>Not Deal</p>
        </div>
        <div style={{
          backgroundColor: '#f7f7f7',
          padding: 10,
          border: '1px solid #ddd',
          borderRadius: 10,
          width: 150,
          margin: 10,
          textAlign: 'center'
        }}>
          <h1>9999999</h1>
          <p>Total</p>
        </div>
      </div>
          <Tabs
            selectedIndex={this.state.tabIndex}
            onSelect={(tabIndex) => this.resetTab(tabIndex)}
          >
            <TabList>
              <Tab>NEW</Tab>
              <Tab>Pending</Tab>
              <Tab>Deal</Tab>
              <Tab>Not Deal</Tab>
              <Tab>Dead</Tab>
            </TabList>
            <TabPanel>
              {/* UNIT panel  */}
              <div>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                
                  <div style={{ marginTop: "4px", marginBottom:"10px"}}>
                    <Button
                      type="button"
                      style={{ width: "130px" }}
                      className="btn btn-plus background-red margin-left-15px"
                      valueCombo={this.state.data.companyIdSelect}
                      onClick={this.openCreateForm.bind(this)}
                    >
                      <span>
                        <i
                          className="fa fa-filter"
                          style={{ marginRight: "10px" }}
                        />
                        Filter
                      </span>
                    </Button>
                  </div>
                </div>
              </div>
              <div>
                <div className="padding-top-3px">
                  <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                      key={toCount}
                      title={"Series List"}
                      subtitle={"Setting data of Series List"}
                      data={this.state.dataTable}
                      columns={this.columnsUser}
                      options={tableOptions}
                      // buttonCreate={this.state.buttonAccess.btnAdd}
                      // onCreate={this.openCreateForm.bind(this)}
                    />
                  </MuiThemeProvider>
                </div>
              </div>
            </TabPanel>
          </Tabs>
        </div>

        <div>
          {this.state.createVisible && (
            <FormVarian
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.createVisible2 && (
            <FormKSU
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm2.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.createVisible3 && (
            <FormBattery
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm3.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.updateVisible && (
            <FormVarian
              type={this.state.popupType === "update" ? "edit" : "view"}
              data={this.state.rawData[this.state.selectedIndex]}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openUpdateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.savePopUpVisible && (
            <PopUp
              type={"save"}
              class={"app-popup app-popup-show"}
              onClick={this.handlePopUp.bind(this)}
            />
          )}

          {this.state.failedPopUpVisible && (
            <PopUp
              type={"confirm"}
              class={"app-popup app-popup-show"}
              onClick={this.handlePopUp2.bind(this)}
            />
          )}

          {this.state.deletePopUpVisible && (
            <PopUp
              type={"delete"}
              class={"app-popup app-popup-show"}
              onClickDelete={this.handleDelete}
              onClick={this.openDeletePopup}
              isLoading={this.state.loadSave}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    masterdata: state.masterdata,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authLogout: () => dispatch(AuthAction.authLogout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(prospek);
